<!--
 * @Description: 父框架布局
 * @Author: PF
 * @Date: 2023-11-23 17:20:29
 * @LastEditors: PF
 * @LastEditTime: 2026-10-09 15:17:50
-->

<template>
  <el-container class="layout">
    <el-header class="pl0 pr0">
      <div class="layout-header" style="display: flex;justify-content: space-between; padding-right: 10px;">
        <div style="display: flex;width: calc(100% - 270px);">
          <div class="header-title h60">
            <!-- 左侧导航栏开关按钮 -->
            <div class="icon spacing pointer select_main_tone ml10 mr10">
              <el-icon :size="30" v-if="isDrawer" @click="drawerClose">
                <Close />
              </el-icon>
              <el-icon style="font-size: 2em; line-height: 20px" v-else @click="leftMenu"><Menu /></el-icon>
            </div>
            <div class="logo spacing pointer mr10" @click="logoClick()">
              <el-image style="width: 30px; height: 30px" :src="baseUrl+userInfo.xxlogo" fit="contain">
                <template #error>
                  <div class="image-slot">
                    <span class="iconfont icon-tupian" style="color: #fff; font-size: 30px;"></span>
                  </div>
                </template>
              </el-image>
            </div>
            <div class="title spacing pointer mr10" @click="logoClick()">{{userInfo.xxmc}}</div>
          </div>
          <div class="header-tag h60" :style="'width: calc(100% - ' + logoWidth + 'px);'">
            <!-- ✅ 修改：:key 从 index 改为 item.id，:name 绑定 item.id -->
            <el-tabs type="border-card" v-model="currentSystemId" closable class="wp100" @tab-remove="handleTabRemove" @tab-change="handleTabChange">
              <el-tab-pane v-for="item in system" :key="item.id" :name="item.id">
                <template #label>
                  <span class="mr4">{{item.cdmc}}</span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!-- 图标按钮组 -->
        <div class="header-but-group h60">
          <span v-if="xtszData.AIDuiHua.sfxs" class="iconfont icon-AI spacing pointer" style="color: #409eff; font-size: 20px;" @click="toAiWenDa()"></span>
          <div class="spacing pointer" v-if="xtszData.xqgl.sfxs" style="display: flex" @click="openXqgl=true">
            <el-icon style="font-size: 20px;"><Opportunity /></el-icon>
          </div>
          <el-badge v-if="xiaoXiShu" :value="xiaoXiShu" :max="99" class="spacing pointer" @click="openDaiBanShiXiang=true">
            <span class="iconfont icon-tongzhi" style="color: #fff;font-size: 20px"></span>
          </el-badge>
          <div v-else class="spacing pointer" @click="openDaiBanShiXiang=true">
            <span class="iconfont icon-tongzhi" style="color: #fff;font-size: 20px"></span>
          </div>
          <el-dropdown class="spacing pointer">
            <span class="el-dropdown-link">
              <span class="iconfont icon-geren mr5" style="color: #fff; font-size: 20px;"></span>
              <span style="color: #fff;">{{ userInfo.xm }}</span>
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-if="xtszData.grzx.sfxs" @click="geRenZhongXinClick()">个人中心</el-dropdown-item>
                <el-dropdown-item @click="openXiuGaiMiMa=true">修改密码</el-dropdown-item>
                <el-dropdown-item @click="signOut">退出</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <el-main>
      <fuwudating v-if="currentSystemId==='1'" />
      <router-view v-else v-slot="{ Component }">
        <KeepAlive v-if="$route.meta.keepAlive">
          <component :is="Component"></component>
        </KeepAlive>
        <component v-if="!$route.meta.keepAlive" :is="Component" />
      </router-view>
    </el-main>
    <el-footer>
      <div class="ye_jiao">{{ yejiao.mc }}： {{ yejiao.nr }}<span v-if="yejiao.lxfs" class="ml20">联系方式：{{ yejiao.lxfs }}</span></div>
    </el-footer>
  </el-container>

  <systemMenu v-if="xtszData.zcd.cdlx === 1" v-model:isDrawer="isDrawer" :row="{list:xtData,userInfo:userInfo}" />
  <systemMenuXiao v-if="xtszData.zcd.cdlx === 2" v-model:isDrawer="isDrawer" :row="{list:xtData,userInfo:userInfo}" />
  <xiugaimima v-model:openXiuGaiMiMa="openXiuGaiMiMa" :xiugaimimaObj="xiugaimimaObj" @ReturnData="signOut" />
  <daibanshixiang v-if="openDaiBanShiXiang" v-model:openDaiBanShiXiang="openDaiBanShiXiang" />
  <xuqiuguanli v-if="openXqgl" v-model:openList="openXqgl" />
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { backToLogout } from '@/utils/login.js'
import { actionPost } from '@/api/common.js'
import systemMenu from './systemMenu.vue'
import systemMenuXiao from './systemMenuXiao.vue'
import fuwudating from '../home.vue'
import xiugaimima from '@/components/gerenzhongxin/xiugaimima.vue'
import daibanshixiang from '@/components/home/daibanshixiang/list.vue'
import xuqiuguanli from '@/views/xuqiuguanli/index.vue'

const router = useRouter()

// ===== 系统设置 =====
const xtszData = ref({ xqgl: {}, grzx: {}, zcd: {}, AIDuiHua: {} })
const initXiTongSheZhi = () => {
  const obj = {
    grzx: { cdwybs: 'geRenZhongXin', sfxs: true, cdlx: 0, bz: '个人中心' },
    lsgz: { cdwybs: 'linShiGongZuo', sfxs: true, cdlx: 0, bz: '首页-临时工作' },
    rcgz: { cdwybs: 'riChangGongZuo', sfxs: true, cdlx: 0, bz: '首页-日常工作' },
    ywp: { cdwybs: 'yiWeiPai', sfxs: true, cdlx: 0, bz: '首页-已委派' },
    yyj: { cdwybs: 'yiYiJiao', sfxs: true, cdlx: 0, bz: '首页-已移交' },
    xtjs: { cdwybs: 'xiTongJieShao', sfxs: true, cdlx: 0, bz: '系统介绍' },
    xqgl: { cdwybs: 'xuQiuGuanLi', sfxs: true, cdlx: 0, bz: '需求管理' },
    zbxx: { cdwybs: 'zhiBanXinXi', sfxs: true, cdlx: 1, bz: '值班信息 1-办公值班 2-宿舍值班' },
    xsxq: { cdwybs: 'xueShengXiangQing', sfxs: true, cdlx: 1, bz: '学生详情 1-默认 2-部分' },
    zcd: { cdwybs: 'zhuCaiDan', sfxs: true, cdlx: 1, bz: '主菜单 1-默认 2-小号一列' },
    zwty: { cdwybs: 'zhiWuTongYong', sfxs: true, cdlx: 0, bz: '职务-通用' },
    AIDuiHua: { cdwybs: 'AIDuiHua', sfxs: true, cdlx: 0, bz: 'AI对话' }
  }
  actionPost({ url: '/api/v2/sys/caidanxianshikongzhi/list', data: { order: 'cdwybs', sort: 'asc' } }).then((res) => {
    if (res.data.length) {
      res.data.forEach(item => {
        const key = Object.keys(obj).find(k => obj[k].cdwybs === item.cdwybs)
        if (key) obj[key] = item
      })
    }
    xtszData.value = obj
    sessionStorage.setItem('XITONGSHEZHI', JSON.stringify(obj))
  })
}
initXiTongSheZhi()

// ===== 菜单列表 =====
const xtData = ref([])
const pathName = ref(location.pathname)

// ✅ 新增：统一路由→系统标签同步方法（核心修复）
const syncSystemTagByPath = (path) => {
  if (!xtData.value.length) return // 菜单还没加载好，暂不执行

  const pathArr = path.split('/').filter(item => item.length !== 0)
  if (pathArr.length === 0) {
    sessionStorage.setItem('CURRENT_SYSTEM_ID', '1')
    currentSystemId.value = '1'
    return
  }

  // ✅ 优化匹配：先精确匹配当前路径，再匹配 /home 入口，最后匹配 HOME 节点
  const xtExists = xtData.value.find(val => val.cdlj === path) ||
                 xtData.value.find(val => val.cdlj === ('/' + pathArr[0] + '/home')) ||
                 xtData.value.find(val => val.zjmc === 'HOME')

  if (!xtExists) return

  const systemMenu = JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST')) || []
  const exists = systemMenu.some(val => val.id === xtExists.id)

  if (!exists) {
    systemMenu.push({ ...xtExists, children: [] })
    sessionStorage.setItem('SET_SYSTEM_LIST', JSON.stringify(systemMenu))
  }

  // ✅ 关键：同时更新 ref 和 sessionStorage，确保视图响应
  system.value = systemMenu
  currentSystemId.value = xtExists.id
  sessionStorage.setItem('CURRENT_SYSTEM_ID', xtExists.id)
  sessionStorage.setItem('CURRENT_SYSTEM_NAME', xtExists.cdmc)
}

// ✅ 简化：初始化标签委托给 syncSystemTagByPath
const addMenuTag = () => {
  syncSystemTagByPath(pathName.value)
}

actionPost({ url: '/api/v2/sys/menu/denglurentree', data: {} }).then((res) => {
  if (res.code === 200) {
    xtData.value = res.data
    initYongHuXinXi(res.data)
    addMenuTag() // 初始化标签
    // ✅ 新增：菜单加载完后，用当前路由再同步一次（解决"先跳转后加载"的时序问题）
    syncSystemTagByPath(router.currentRoute.value.path)
  }
})

// 根据当前 URL 自动恢复/生成系统标签（保留原方法名，逻辑已简化）
// addMenuTag 已在上方定义

// ===== 用户信息 =====
const userInfo = ref({ id: '', gh: '', xm: '', zp: '', csrq: '', grzxId: '' })
const initYongHuXinXi = (list) => {
  const info = list.find(item => item.zjmc === 'GERENZHONGXIN')
  actionPost({ url: '/api/v2/account/getCurrentUserJzg', data: {} }).then((res) => {
    if (res.code === 200) {
      userInfo.value = {
        id: res.data.id,
        gh: res.data.gh,
        xm: res.data.xm,
        zp: res.data.zp,
        csrq: res.data.csrq,
        grzxId: info ? info.id : '',
        grzxInfo: info || {}
      }
      sessionStorage.setItem('USER_INFO', JSON.stringify(userInfo.value))
      initXtxx()
      getxiaoxi()
    }
  })
}

const baseUrl = ref(process.env.VUE_APP_BASE_API)
const openDaiBanShiXiang = ref(false)
const openXiuGaiMiMa = ref(false)
const xiugaimimaObj = ref()
const currentSystemId = ref(sessionStorage.getItem('CURRENT_SYSTEM_ID') || '1')
const system = ref(JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST')) || [])
const isDrawer = ref(false)

// ===== 学校信息 =====
const logoWidth = ref(400)
const initXtxx = () => {
  actionPost({ url: '/api/v2/pdp/xuexiao/entity', data: {} }).then((res) => {
    document.title = res.data.xxmc
    const favicon = document.querySelector('link[rel="icon"]')
    if (favicon) favicon.href = baseUrl.value + res.data.xxlogo
    userInfo.value.xxid = res.data.id
    userInfo.value.xxmc = res.data.xxmc
    userInfo.value.xxlogo = res.data.xxlogo
    sessionStorage.setItem('USER_INFO', JSON.stringify(userInfo.value))
    window.setInterval(() => {
      const titleEl = document.querySelector('.header-title')
      if (titleEl) logoWidth.value = titleEl.clientWidth
    }, 20000)
    if (!sessionStorage.getItem('CURRENT_SYSTEM_ID')) {
      sessionStorage.setItem('CURRENT_SYSTEM_ID', userInfo.value.grzxId)
      sessionStorage.setItem('CURRENT_SYSTEM_NAME', '首页')
    }
  })
}

const logoClick = () => {
  sessionStorage.setItem('CURRENT_SYSTEM_ID', userInfo.value.grzxId || '1')
  sessionStorage.setItem('CURRENT_SYSTEM_NAME', '首页')
  currentSystemId.value = '1'
  sessionStorage.setItem('menuId', userInfo.value.grzxId || '')
  sessionStorage.setItem('menuName', '首页')
  router.push({ path: '/', query: { t: Date.now() } })
}

const geRenZhongXinClick = () => {
  const home = userInfo.value.grzxInfo || {}
  const systemMenu = JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST')) || []
  if (!systemMenu.some(val => val.id === home.id)) {
    systemMenu.push({ ...home, children: [] })
    sessionStorage.setItem('SET_SYSTEM_LIST', JSON.stringify(systemMenu))
  }
  sessionStorage.setItem('CURRENT_SYSTEM_ID', home.id)
  router.push({ path: home.cdlj, query: { t: Date.now() } })
}

// ===== 系统标签操作（优化核心）=====
const handleTabChange = (val) => {
  sessionStorage.setItem('CURRENT_SYSTEM_ID', val)
  if (val === '1') {
    xiTongCaiDanClick(val)
  } else {
    const info = system.value.find(item => item.id === val)
    if (info) {
      sessionStorage.setItem('CURRENT_SYSTEM_NAME', info.cdmc)
      sessionStorage.setItem('menuId', info.id)
      sessionStorage.setItem('menuName', '首页')
      // 使用 router.push 内部跳转，不刷新页面
      router.push(info.cdlj)
    }
  }
}

const xiTongCaiDanClick = (val) => {
  const info = system.value.find(item => item.id === val)
  currentSystemId.value = val
  sessionStorage.setItem('menuId', userInfo.value.grzxId || '')
  sessionStorage.setItem('menuName', '首页')
  if (info) {
    if (info.zjmc === 'HOME' || val === '1') {
      logoClick()
    } else {
      sessionStorage.setItem('CURRENT_SYSTEM_NAME', info.cdmc)
      router.push({ path: info.cdlj, query: { t: Date.now() } })
    }
  } else {
    if (val === '1') {
      sessionStorage.setItem('CURRENT_SYSTEM_NAME', '首页')
      router.push({ path: '/', query: { t: Date.now() } })
    }
  }
}

// 删除系统标签
const handleTabRemove = (val) => {
  if (val === '1') return // 首页不可关闭
  system.value = system.value.filter(element => element.id !== val)
  sessionStorage.setItem('SET_SYSTEM_LIST', JSON.stringify(system.value))
  // 删除的是当前激活的系统，跳回首页
  if (val === currentSystemId.value) {
    sessionStorage.setItem('CURRENT_SYSTEM_ID', '1')
    sessionStorage.setItem('CURRENT_SYSTEM_NAME', '首页')
    sessionStorage.setItem('menuId', userInfo.value.grzxId || '')
    sessionStorage.setItem('menuName', '首页')
    currentSystemId.value = '1'
    router.push({ path: '/', query: { t: Date.now() } })
  }
}

const leftMenu = () => { isDrawer.value = true }
const drawerClose = () => { isDrawer.value = false }
const signOut = async () => {
  sessionStorage.clear()
  backToLogout()
}
const toAiWenDa = () => { window.open('/wenAi', '_blank') }
const openXqgl = ref(false)

// ===== 消息轮询 =====
const xiaoXiShu = ref()
const getxiaoxi = () => {
  actionPost({
    url: '/api/v2/bangong/bangongdaibanshixiang/myshenpibanli',
    data: { jzgid: userInfo.value.id, zt: 0, order: 'gh', sort: 'asc' }
  }).then((res) => {
    if (res.code === 200) xiaoXiShu.value = res.data.length
  })
}
const timer = ref(null)
const lunXun = () => {
  timer.value = window.setInterval(() => { setTimeout(getxiaoxi, 600) }, 60000)
}
lunXun()

// ===== 页脚 =====
const yejiao = ref({ mc: '', nr: '', lxfs: '' })
actionPost({ url: '/api/v2/sys/jishuzhichi/entity', data: {} }).then((res) => {
  yejiao.value = res.data
})

// ✅ 修改：watch 委托给 syncSystemTagByPath，匹配逻辑已在方法内优化
watch(() => router.currentRoute.value.path, (newPath) => {
  syncSystemTagByPath(newPath)
}, { immediate: false })
</script>

<style lang="less" scoped>
/* 样式保持不变，与原代码一致 */
.layout {
  width: 100vw; height: 100vh !important;
  .el-main { width: 100vw; margin: 0; padding: 0; overflow: hidden; }
  .header-title { display: flex; align-items: center; width: fit-content;
    .title { font-weight: bold; font-size: 24px; }
    .logo { width: 30px; height: 30px; }
    .icon { width: 30px; height: 30px; }
  }
  .header-tag { height: 60px; line-height: 60px; width: 100%; display: flex; align-items: center;
    :deep(.el-tabs__header) { background-color: transparent !important; height: 60px; line-height: 60px; border: 0; margin: 0; }
    :deep(.el-tabs__nav) { font-size: 14px; height: 35px; line-height: 35px; padding: 0 16px; }
    :deep(.el-tabs__content) { display: none; }
  }
  .header-but-group { display: flex; align-items: center; justify-content: flex-end; height: 60px;
    .spacing + .spacing { margin-left: 20px; }
    i { color: #fff; }
    .el-badge { height: 32px;
      :deep(.el-badge__content.is-fixed) { top: 4px; transform: translateY(-60%) translateX(90%); }
    }
  }
  .el-footer { height: auto; background-color: #23262e; color: #fff; display: flex; justify-content: center; align-items: center;
    .ye_jiao { max-width: 1200px; padding: 10px; }
  }
}
</style>
